import { SqMoney } from "../api/squarespace";
import { Batch } from "../models/Batch";
import { RecipeContainer } from "../models/Recipe";

export const costTotal = (batch: Batch): number => {
  if (!batch.recipe || !batch.recipe.ingredients || batch.recipe.ingredients.length === 0) {
    return 0;
  }

  const { ingredients } = batch.recipe;

  // Safely calculate the recipe yield
  const recipeYield = batch.recipe.batchSize ?? batch.expectedYield ?? batch.volume ?? 1;
  const batchYield = batch.expectedYield ?? batch.volume ?? 1;

  // Prevent division by zero
  if (!recipeYield || !batchYield) return 0;

  const scalingFactor = batchYield / recipeYield;

  const totalCost = ingredients.reduce((total, ingredient) => {
    const { item, quantity } = ingredient;
    if (!item || typeof item.price !== "number" || typeof quantity !== "number") return total;

    const finalQuantity = batch.ingredientsConfirmed
      ? quantity
      : quantity * scalingFactor;

    return total + finalQuantity * item.price;
  }, 0);

  return totalCost;
};


export const costPerUnit = (batch: Batch): number => {
  if (!batch || !batch.quantity) return 0;

  const batchYield = batch.expectedYield ?? batch.volume ?? 1;

  if (batchYield <= 0) return 0;

  return costTotal(batch) / batchYield;
};

export const costPerContainer = (
  batch: Batch,
  container: RecipeContainer,
): number => {
  if (!batch) return 0;

  const unitCost = costPerUnit(batch);
  const size = container.sizeL ?? container.containerItem.capacityL ?? 0;

  let total = unitCost * size;

  if (typeof container.containerItem.price === "number") {
    total += container.containerItem.price;
  }

  if (container.components?.length) {
    total += container.components.reduce((sum, comp) => {
      const price = comp.item?.price ?? 0;
      const amount = comp.amountPerContainer ?? 0;
      return sum + price * amount;
    }, 0);
  }

  return total;
};

export const asPrice = (pricing: SqMoney): string => {
  if (!pricing || !pricing.currency || !pricing.value) return "";
  return `${pricing.currency} ${pricing.value}`;
}
